import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  PropertySetDetailsMode,
  PropertySetsState,
  PropertySetView,
} from '../property-sets-dialog/property-sets-dialog';
import { StateProvider } from '../services/state-provider/state-provider';

const defaultState = {
  view: PropertySetView.List,
  ids: [],
  id: null,
  mode: PropertySetDetailsMode.Read,
} as PropertySetsState;

@Injectable({ providedIn: 'root' })
export class PropertySetsStateProviderService implements StateProvider<PropertySetsState> {
  #state = new BehaviorSubject<PropertySetsState>({ ...defaultState });
  stateChanges$ = this.#state.asObservable();

  public patchState(patch: Partial<PropertySetsState>): void {
    this.#state.next({ ...this.snapshot(), ...patch });
  }

  public snapshot(): PropertySetsState {
    return { ...this.#state.value };
  }

  public setView(view: PropertySetView): void {
    this.patchState({ view });
  }

  public setMode(mode: PropertySetDetailsMode): void {
    this.patchState({ mode });
  }

  public selectPropertySet(id: number): void {
    this.patchState({ id, view: PropertySetView.Details, hasBackButton: true });
  }

  reset() {
    this.#state.next(defaultState);
  }
}
